import type { AssetWorkflowOptions } from '../../types';

export const createPackagingSet: AssetWorkflowOptions = {
  workflowKey: 'createPackagingSetWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'packagingSet',
  workflowIndex: 1,
  workflowName: 'Add Packaging Set ',
  workflowDescription: `Create a set of packaging options to be used together`,
  workflowAssets: [],
  workflowStepOptions: [
    {
      workflowStepKey: 'name',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'What will you call this packaging set?',
        description:
          'Use a name that will allow you to quickly identify what this set of boxes is used for. EG something that includes the name of the facility they are used in',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'properties',
        properties: ['name'],
      },
    },
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Packaging Set ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Would you like to give this packaging set a custom ID?',
        description:
          'You may optionally define this ID, and it can be used in lieu of the Shipium generated Packaging Set ID.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'description',
      workflowStepNavigationName: 'Description',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 4,
        defaultValue: '',
        prompt: 'Enter a description (optional):',
        description: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'assetSetSelect',
      workflowStepNavigationName: 'Packaging Select',
      workflowComponent: {
        workflowComponentType: 'assetSetSelect',
        assetType: 'packaging',
        singleSelect: false,
        optional: true,
        assetIdProperty: 'packagingId',
        prompt: 'Select the packages that should be used in this set',
        description: '',
        help: '',
      },
      assetToWorkflowStateMapping: {
        assetProperty: 'packagingIds',
      },
      workflowStateToAssetMapping: {
        mappingType: 'link',
        linkAssetTypeOverride: 'packagings',
        linkAssetType: 'packaging',
        list: true,
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Packaging Set Summary',
        description: 'The following packaging set will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
